<div [class]="'card school-info-card p-2 shadow-sm'">
  <div class="card-container" [formGroup]="form">
    <h4 class="mt-1 mb-3">
      {{getTextbausteinOrTranslate(KeyString.ANGABEN_SCHULE_TITEL_TICKET, 'STANDARD.ANGABEN_SCHULE')}}
    </h4>
    <div class="m-4">
      @if (effectivelyVisible?.includes('schuleId')) {
        <div class="form-group sfk-form-vertical-spacer group-for-schoolId col mt-0 mb-0">
          <app-custom-select
            id="schoolId"
            [class]="'sfk-ellipsed-ng-select'"
            [customFormGroup]="form"
            placeholder="-"
            [items]="schoolList"
            [multiple]="false"
            [clearable]="false"
            bindLabel="name"
            bindValue="id"
            [label]="getFieldLabelOrTranslate('schuleId','STANDARD.SCHULE')"
            [infoText]="getTextbausteinOrTranslate(KeyString.SCHULE_INFO,'STANDARD.SCHULE_INFO')"
            [readonly]="!isEntwurf"
            data-cy="schule"
          ></app-custom-select>
        </div>
      }

      @if (getFormItem('schoolId')?.value) {
        <div class="form-group sfk-form-vertical-spacer group-for-schoolType col mt-0 mb-0">
          <app-custom-select
            id="schoolType"
            [class]="'sfk-ellipsed-ng-select'"
            [customFormGroup]="form"
            [items]="optionSchoolType"
            [multiple]="false"
            bindLabel="name"
            bindValue="id"
            [label]="getFieldLabelOrTranslate('schoolType','STANDARD.SCHOOL_TYPE')"
            [readonly]="true"
            data-cy="schoolType"
          ></app-custom-select>
        </div>
      }

      @if (isBerufskolleg(getFormItem('schoolId')?.value) && effectivelyVisible?.includes('bildungsgangId')) {
        <div class="form-group sfk-form-vertical-spacer group-for-bildungsgangId col mt-0 mb-0">
          <app-custom-select
            id="courseId"
            [class]="'sfk-ellipsed-ng-select'"
            [customFormGroup]="form"
            [placeholder]="!getFormItem('schoolId')?.value ? ('SCHOOL_DATA.SELECT_SCHOOL_FIRST' | translate) : '-'"
            [items]="courseList"
            [multiple]="false"
            bindLabel="name"
            bindValue="id"
            [label]="getFieldLabelOrTranslate('bildungsgangId','STANDARD.BILDUNGSGANG')"
            [infoText]="getTextbausteinOrTranslate(KeyString.BILDUNGSGANG_INFO,'STANDARD.BILDUNGSGANG_INFO')"
            [infoTextBelowInput]="getTextbausteinOrTranslate(KeyString.BILDUNGSGANG_INFO_BELOW,'')"
            [readonly]="!isEntwurf"
            data-cy="bildungsgang"
          ></app-custom-select>
        </div>
      }
      @if (getFormItem('schoolId')?.value && isBerufskolleg(getFormItem('schoolId')?.value) && effectivelyVisible?.includes('bildungsgangdatum')) {
        <div
          class="form-group sfk-form-vertical-spacer group-for-courseDate col mt-0 mb-0"
        >
          <app-custom-input
            id="courseDate"
            type="date"
            [customFormGroup]="form"
            [label]="getFieldLabelOrTranslate('bildungsgangdatum','STANDARD.BILDUNGSGANG_DATUM')"
            [infoText]="getTextbausteinOrTranslate(KeyString.BILDUNGSGANGDATUM_INFO,'STANDARD.BILDUNGSGANG_DATUM_INFO')"
            [readonly]="!isEntwurf"
            data-content="dd.mm.yyyy"
            [min]="minDate | date:'yyyy-MM-dd'"
            data-cy="courseDate"
          ></app-custom-input>
        </div>
      }

      @if (getFormItem('schoolId')?.value && effectivelyVisible?.includes('schuljahrId')) {
        <div
          class="form-group sfk-form-vertical-spacer group-for-schuljahr col mt-0 mb-0">
          <app-custom-select
            id="schoolYearId"
            [class]="'sfk-ellipsed-ng-select'"
            [customFormGroup]="form"
            placeholder="-"
            [items]="schoolYearList"
            [multiple]="false"
            [clearable]="false"
            bindLabel="name"
            bindValue="id"
            [label]="getFieldLabelOrTranslate('schuljahrId','STANDARD.SCHULJAHR')"
            [infoText]="getTextbausteinOrTranslate(KeyString.SCHULJAHR_INFO,'STANDARD.SCHULJAHR_INFO')"
            [readonly]="!isEntwurf"
            data-cy="schuljahr"
          ></app-custom-select>
        </div>
      }

      @if (getFormItem('schoolId')?.value && !isBerufskolleg(getFormItem('schoolId')?.value) && effectivelyVisible?.includes('klasseId')) {
        <div
          class="form-group sfk-form-vertical-spacer group-for-klasseId col mt-0 mb-0">
          <app-custom-select
            id="classId"
            [class]="'sfk-ellipsed-ng-select'"
            [customFormGroup]="form"
            [placeholder]="!getFormItem('schoolId')?.value ? ('SCHOOL_DATA.SELECT_SCHOOL_FIRST' | translate) : '-'"
            [items]="classList"
            [multiple]="false"
            [clearable]="false"
            bindLabel="name"
            bindValue="id"
            [label]="getFieldLabelOrTranslate('klasseId','STANDARD.SCHULKLASSE')"
            [infoText]="getTextbausteinOrTranslate(KeyString.KLASSE_INFO,'STANDARD.SCHULKLASSE_INFO')"
            [readonly]="!isEntwurf"
            data-cy="klasse"
          ></app-custom-select>
        </div>
      }
      @if(showSchoolLevel){
        <div class="form-group group-for-school-level col mb-3">
          <div class="flex-grow-1 mr-2">
            <app-custom-select id="schoolLevel"
                               [customFormGroup]="form"
                               [items]="optionSchoolLevel"
                               bindLabel="translation"
                               bindValue="name"
                               label="{{'SCHULEN-DETAIL.SCHOOL_LEVEL' |translate }}"
                               [multiple]="false"
                               [clearable]="false"
                               [readonly]="!isEntwurf"
                               [customStringTemplate]="schoolLevelCustomName"
            >
              <!-- the following template defines how to display items in the dropdown-->
              <ng-template #schoolLevelCustomName let-item='item'>
                {{'SCHULEN-DETAIL.SCHOOL_LEVEL_ENUM.' + item?.translation |translate }}
              </ng-template>
              ></app-custom-select>
          </div>
        </div>
      }

      @if (wegtyp === 'BEIDES' && effectivelyVisible?.includes('schultageJeWoche')) {
        <div
          class="form-group sfk-form-vertical-spacer group-for-schoolDaysAWeek col  mb-0 mt-0"
        >
          <label for="schoolDaysAWeek">
            {{getFieldLabelOrTranslate('schultageJeWoche', 'TICKETDETAIL.PRAKTIKUM.SCHULTAGE_JE_WOCHE')}}
          </label>
          <br>
          <input
            id="schoolDaysAWeek"
            type="number" min="0"
            class="form-control"
            formControlName="schoolDaysAWeek"
            [readonly]="!isEntwurf"
            data-cy="schoolDaysAWeek"
          />
        </div>
      }

      <input class="btn btn-primary school-info-save-btn"
             type="button"
             (click)="onUpdateSchoolInfoClick()"
             [value]="'TICKETDETAIL.SCHOOL_INFO.UPDATE_BUTTON' | translate"
             [title]="'TICKETDETAIL.SCHOOL_INFO.UPDATE_BUTTON' | translate"
             [attr.disabled]="!isEntwurf ? true : null">
    </div>

  </div>
</div>

